import { Container, Row, Col } from 'react-bootstrap';
import { BASE_PATH } from '@utils/Environment';

function SurveySuccess() {
  const handleRedirect = () => {
    const fullPath = `${window.location.origin}${BASE_PATH}survey`;
    window.location.href = fullPath;
  };

  return (
    <Container
      fluid
      className="vh-100 d-flex align-items-center justify-content-center"
    >
      <Row className="text-center">
        <Col>
          <h3 className="display-6 text-success">
            Survey Submitted Successfully!
          </h3>
          <p className="lead">
            You&apos;ll be notified once your survey has been approved.
          </p>
          <button
            type="button"
            onClick={handleRedirect}
            className="btn btn-primary"
          >
            Return to Surveys
          </button>
        </Col>
      </Row>
    </Container>
  );
}

export default SurveySuccess;
